import React from 'react';
import { Dialog } from '../../../components/CommonComponents/Dialog/Dialog';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import WarningImg from "../../../assets/images/svgs/yellowwarming.svg";
import { BASE_URL } from '../../../constants/Constants';

type OverrideDialogProps = {
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    overrideReason: string;
    setOverrideReason: (reason: string) => void;
    textAreaRef: React.RefObject<HTMLTextAreaElement>;
};

const OverrideDialog: React.FC<OverrideDialogProps> = ({
    show,
    onHide,
    onConfirm,
    overrideReason,
    setOverrideReason,
    textAreaRef
}) => {
    return (
        <Dialog open={show} onClose={onHide}>
            <div className="w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl py-4 sm:py-6 md:py-8 lg:py-10 xl:py-6 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 cursor-pointer">
                <div className="p-2  flex justify-center items-center">
                    <img src={`${BASE_URL}/api/logo`} alt="Logo" />
                </div>

                <div className="w-full text-center mb-4">
                    <h2 className="text-xl font-semibold mb-2">
                        Do you want to override the Level 1 & Level 2 approvals?
                    </h2>
                    <p className="text-base text-gray-600">
                        Once the approvals are overridden, you cannot undo it.
                    </p>
                </div>

                <Form.Group controlId="overrideReason" className="w-full mb-4">
                    <Form.Label className="text-sm font-semibold">Override Reason</Form.Label>
                    <textarea
                        ref={textAreaRef}
                        className="w-full p-2 text-sm border rounded-lg"
                        rows={3}
                        style={{ height: '120px', minHeight: '120px' }}
                        placeholder="Enter Override Reason"
                        value={overrideReason}
                        onChange={(e) => setOverrideReason(e.target.value)}
                    ></textarea>
                </Form.Group>

                <div className="flex justify-center space-x-4 w-full">


                    <button
                        className="bg-primary px-6 py-2 font-bold text-white rounded-full"
                        onClick={onConfirm}
                    >
                        Override
                    </button>
                    <button
                        className="bg-gray-500 px-6 py-2 font-bold text-white rounded-full"
                        onClick={onHide}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default OverrideDialog;